import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=143dda8e&scoped=true&"
import script from "./MainPanel.vue?vue&type=script&lang=js&"
export * from "./MainPanel.vue?vue&type=script&lang=js&"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=143dda8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143dda8e",
  null
  
)

export default component.exports